import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { RootState } from 'store';
import { ReleaseTask } from '../../../../types/releaseTask';
import {
  REGISTRATION_STEP,
  RegistrationStep,
} from '../../../../constants/registrationStep';

/**
 * リリースタスク更新画面の状態
 */
interface EditState {
  /** ロード状態 */
  loading: boolean;
  /** 表示中のタスク */
  selected: ReleaseTask | undefined;
  /** 削除確認モーダルの表示状態 */
  isOpenModalDelete: boolean;
  /** 基本情報の更新確認モーダルの表示状態 */
  isOpenModalEdit: boolean;
  /** バージョン追加ステップ */
  step: RegistrationStep;
}

/**
 * リリースタスク更新画面の初期状態
 */
const initialState: EditState = {
  step: REGISTRATION_STEP.INPUT,
  loading: false,
  selected: undefined,
  isOpenModalDelete: false,
  isOpenModalEdit: false,
};

/**
 * リリースタスク更新画面の slice(reducer + action)
 */
export const editSlice = createSlice({
  name: 'editReleaseTask',
  initialState,
  reducers: {
    initialize: () => initialState,
    modalOpened: (
      state,
      { payload }: PayloadAction<EditState['selected']>,
    ) => ({
      ...state,
      selected: payload,
    }),
    updateLoadingStatus: (state, { payload }: PayloadAction<boolean>) => ({
      ...state,
      loading: payload,
    }),
    updateIsOpenModalDelete: (state, { payload }: PayloadAction<boolean>) => ({
      ...state,
      isOpenModalDelete: payload,
    }),
    updateIsOpenModalEditDetail: (
      state,
      { payload }: PayloadAction<boolean>,
    ) => ({
      ...state,
      isOpenModalEditDetail: payload,
    }),
  },
});

/**
 * リリースタスク更新画面の action
 */
export const editActions = editSlice.actions;

/**
 * リリースタスク更新画面の selectors
 */
export const editSelectors = {
  selectedReleaseTask: (state: RootState) => state.releaseTask.edit.selected,
  isOpenModalDelete: (state: RootState) =>
    state.releaseTask.edit.isOpenModalDelete,
  isOpenModalEdit: (state: RootState) => state.releaseTask.edit.isOpenModalEdit,
  currentModalStep: (state: RootState) => state.releaseTask.registration.step,
} as const;
